import TomSelect, { type TomSelectInstance } from "../utils/tomSelect";

const downloadSelects = document.querySelectorAll<HTMLSelectElement>(".download-select");

downloadSelects.forEach((select) => {
	const updateDownloadHref = (value: string) => {
		const downloadBtn = select.closest(".tab-item-info")?.querySelector("a.btn");
		if (downloadBtn && value) {
			downloadBtn.setAttribute("href", value);
		}
	};

	const firstOption = select.options[0];
	if (firstOption?.value) {
		updateDownloadHref(firstOption.value);
	}

	const existingInstance = (select as HTMLSelectElement & { tomselect?: TomSelectInstance }).tomselect;
	if (existingInstance) {
		existingInstance.destroy();
	}

	new TomSelect(select, {
		create: false,
		// @ts-expect-error Tom Select accepts null to disable the filter input
		controlInput: null,
		closeAfterSelect: true,
		onChange(value: string) {
			updateDownloadHref(value);
		},
	});
});
